import { render } from "./filter-collection.vue?vue&type=template&id=787c0356"
import script from "./filter-collection.vue?vue&type=script&lang=js"
export * from "./filter-collection.vue?vue&type=script&lang=js"

import "./filter-collection.vue?vue&type=style&index=0&id=787c0356&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__